import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import SuppliersTable from "../../components/Tables/SuppliersTable";
import ManagementPageHero from "../../components/ManagementPageHero";
class Suppliers extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewCustomerPermission = userPermissions.includes('new customer');
    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Tedarikçiler"
                Breadcrumb={[
                  {name: "Tedarikçiler", navigate: ""},

                ]}
            />
            <ManagementPageHero
              eyebrow="TEDARİKÇİ YÖNETİMİ"
              title="Tedarikçi ağınızı yönetin"
              description="Tedarikçi kayıtlarını, iletişim bilgilerini ve ilişkili hareketleri düzenli biçimde takip edin."
              actionTo={userHasNewCustomerPermission ? "/customer-add" : null}
              actionLabel="Yeni tedarikçi"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Tedarikçiler</h2>
                    {userHasNewCustomerPermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="customer-add">Yeni Müşteri/Tedarikçi</Link>
                              </li>

                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}
                  </div>
                  <div className="body">
                    <SuppliersTable>

                    </SuppliersTable>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(connect(mapStateToProps, {})(Suppliers));
